import { useState, useEffect, useCallback } from "react";
import { Search, ShieldAlert } from "lucide-react";
import api from "../lib/api";
import { timeAgo, clsx } from "../lib/format";
import { Input } from "../components/ui/input";

const COLOR = (a) => a.includes("delete") || a.includes("reject") || a.includes("suspend") ? "text-neg bg-neg/10"
  : a.includes("impersonate") ? "text-gold bg-gold/10"
  : a.includes("approve") || a.includes("create") ? "text-pos bg-pos/10"
  : "text-brandblue bg-brandblue/10";

export default function AdminAudit() {
  const [rows, setRows] = useState([]);
  const [action, setAction] = useState("");
  const [actor, setActor] = useState("");

  const load = useCallback(() => api.get("/admin/audit-logs", { params: { action, actor, limit: 300 } }).then((r) => setRows(r.data)), [action, actor]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3 flex-wrap">
        <div className="relative"><Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-fx-s3" /><Input data-testid="audit-filter-action" value={action} onChange={(e) => setAction(e.target.value)} placeholder="Filter by action" className="pl-9 h-9 bg-fx-s1 border-white/10 w-52" /></div>
        <div className="relative"><Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-fx-s3" /><Input data-testid="audit-filter-actor" value={actor} onChange={(e) => setActor(e.target.value)} placeholder="Filter by actor email" className="pl-9 h-9 bg-fx-s1 border-white/10 w-56" /></div>
        <span className="text-xs text-fx-s3 flex items-center gap-1"><ShieldAlert className="h-3.5 w-3.5" /> Read-only, immutable log</span>
      </div>
      <div className="rounded-xl bg-fx-s1 border border-white/5 overflow-hidden overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[11px] uppercase tracking-wider text-fx-s3 border-b border-white/5">
            <th className="px-4 py-3">Action</th><th className="px-4 py-3">Actor</th><th className="px-4 py-3">Target</th><th className="px-4 py-3">Amount</th><th className="px-4 py-3">IP</th><th className="px-4 py-3">When</th>
          </tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={6} className="px-4 py-8 text-center text-fx-s3">No audit entries.</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} data-testid={`audit-row-${r.id}`} className="border-b border-white/[0.03]">
                <td className="px-4 py-3"><span className={clsx("px-2 py-0.5 rounded text-[11px] font-mono", COLOR(r.action))}>{r.action}</span></td>
                <td className="px-4 py-3 text-xs">
                  <div className="text-fx-s3 font-mono">{r.actor_email}</div>
                  <div className="text-[10px] uppercase text-fx-s3">{r.actor_role}{r.impersonated_user_id ? " · on behalf of customer" : ""}</div>
                </td>
                <td className="px-4 py-3 text-xs text-fx-s3">{r.target_user || r.target_id || "-"}</td>
                <td className="px-4 py-3 font-mono text-xs">{r.amount != null ? `$${Number(r.amount).toLocaleString()}` : "-"}</td>
                <td className="px-4 py-3 font-mono text-[11px] text-fx-s3">{r.ip || "-"}</td>
                <td className="px-4 py-3 text-xs text-fx-s3">{timeAgo(r.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
